// Needed to fix global issue with Vite
// https://stackoverflow.com/questions/72114775/vite-global-is-not-defined
window.global ||= window;
